module.exports = __webpack_public_path__ + "resources/img/theme_pseudo_fullscreen.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/theme_pseudo_fullscreen.gif
// module id = 1369
// module chunks = 0